<template>
  <div>
    <v-card :width="$isMobile ? (windowInnerWidth * 0.98) - 80 : ''" style='background: #f3f4f6; border: 0'>
      <v-card-text>
        <div class='mb-2 font-weight-bold'>
          {{ title }}
        </div>
        <!--        <div v-else class='mb-2 font-weight-bold'>-->
        <!--          {{ messages }}-->
        <!--        </div>-->
        <div style=''>
          <DatePicker
            :min='minDate'
            :minTime="new Date()"
            :placeholder="language === 'chinese' ? '请选择开始时间' : 'Please choose a start time'"
            v-model='startDateTime'
            @changeDate='changeStartDate'
            :language="language"
            :disabled='messageData.dateDisabled'
          ></DatePicker>
        </div>
        <div class='mt-2' style=''>
          <DatePicker
            :placeholder="language === 'chinese' ? '请选择结束时间' : 'Please choose a end time'"
            :min='startDateTime ? startDateTime : minDate'
            v-model='endDateTime'
            class='mt-2'
            :language="language"
            :disabled='messageData.dateDisabled'
          ></DatePicker>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          :disabled='messageData.dateDisabled'
          depressed
          small
          @click="$emit('cancelChat', {language}); messageData.dateDisabled = true"
        >
          {{ language === 'chinese' ? '取消' : 'Cancel' }}
        </v-btn>
        <v-btn
          rounded
          color='#A100FF'
          :disabled='messageData.dateDisabled'
          style='color: white'
          depressed
          small
          @click='submit'
        >
          {{ language === 'chinese' ? '确认' : 'Confirm' }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <message-box
      :msg-id='msgId'
      :like-type='messageData.likeType'
      class='mt-2'
      :message='messageData'
      @copy='copy'
      :isCustomCopyWriteText='true'
      :showRegenerate='false'
      @refreshAnswer="$emit('refreshAnswer', msgId)"
    ></message-box>
  </div>
</template>

<script>
import DatePicker from '@/modules/chat/components/DatePicker/index.vue'
import MessageBox from '../components/MessageBox.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: { DatePicker, MessageBox },
  props: {
    msgId: {
      type: Number,
      default: 0,
    },
    startTime: {
      type: String,
      default: null,
    },
    endTime: {
      type: String,
      default: null,
    },
    messageData: {
      type: Object,
      default: {},
    },
    immediatelyRender: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  data() {
    return {
      startDateTime: null,
      endDateTime: null,
      dates: [], // 用于存储选择的日期范围
      minDate: new Date().toISOString().substr(0, 10), // 最小日期为今天
      // minHour: String(new Date().getHours()),
      // minMinute: String(new Date().getMinutes() - 10),
      isLoading: false, // 加载状态
      messages: '',
      title: '为了更好地为您预订会议室，您先选择一个时间段。',
    }
  },
  watch: {
    startTime: {
      handler(val) {
        this.startDateTime = val
      },
      immediate: true,
    },
    endTime: {
      handler(val) {
        this.endDateTime = val
      },
      immediate: true,
    },
    msgId: {
      handler(val) {
        this.componentInitSet()
      },
      immediate: true,
    },
    language: {
      handler(val) {
        this.title = val === 'chinese' ? '为了更好地为您预订会议室，您先选择一个时间段。' : 'To better book a meeting room for you, please select a time slot first.'
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      chatSessionId: 'chat/chatSessionId',
      modelType: 'chat/modelType',
    }),
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  mounted() {
    if (this.messageData.tipMsg) {
      this.title = this.messageData.tipMsg
    }
    if (!this.immediatelyRender) {
      this.displayMessageCharacterByCharacter(this.title)
    }
  },
  methods: {
    async copy() {
      let copyTemplate = `开始时间：${this.startDateTime}\n` + `结束时间：${this.endDateTime}`
      await navigator.clipboard.writeText(copyTemplate)
      this.$message.success('复制成功')
    },
    componentInitSet() {
      if (this.messageData.componentSelectionValue) {
        const componentSelectionValue = JSON.parse(this.messageData.componentSelectionValue)
        if (componentSelectionValue) {
          this.startDateTime = componentSelectionValue.startDateTime
          this.endDateTime = componentSelectionValue.endDateTime
        }
      }
    },
    displayMessageCharacterByCharacter(text) {
      var char = text.split('')
      for (let i = 0; i < char.length; i++) {
        setTimeout(() => {
          this.messages += char[i]
          this.$forceUpdate() // 强制视图更新以显示最新文本
          // this.scrollToBottom() // 确保新消息可见
        }, i * 150) // 1秒间隔
      }
    },
    submit() {
      if (!this.startDateTime) {
        this.$message.warning('请选择开始时间')
        return
      }
      if (!this.endDateTime) {
        this.$message.warning('请选择结束时间')
        return
      }
      this.$set(this.messageData, 'dateDisabled', this.modelType === 'DeepSeek')
      this.$emit('submit', [this.startDateTime, this.endDateTime, this.msgId])
    },
    changeStartDate(val) {
      let date = new Date(this.startDateTime)
      date.setHours(date.getHours() + 1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // 注意月份是从0开始的
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      this.endDateTime = `${year}-${month}-${day} ${hours}:${minutes}:00`
    },
  },
}
</script>

<style scoped>
/* 自定义样式 */
.date-picker-wrapper {
  position: relative; /* 使按钮可以相对于此容器定位 */
}

.title-class {
  color: #262626;
  font-size: 16px;
}

.confirm-button {
  position: absolute; /* 绝对定位 */
  bottom: 16px; /* 距离底部 16px */
  right: 16px; /* 距离右侧 16px */
  z-index: 1; /* 确保按钮在日历上方 */
}

</style>
